import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import {
    BackToTopButton,
    Button,
    MarkdownContent,
    PageSection,
    PlaceDropdown,
    SectionTitle,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import {
    scrollToHash,
} from 'wanderu-utils';

import ccConfig from '../../../../config/carriercontact.locale';
import RegionalData from './RegionalData/RegionalData';

import styles from './CarrierContactList.scss';

const NUM_COUNTRIES_TO_SHOW = 3;

class CarrierContactList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hideExtraCountries: true,
        };
    }

    _toggleSeeMoreButton = () => {
        this.setState((currentState) => ({
            hideExtraCountries: !currentState.hideExtraCountries,
        }));
    }

    _onCountryChange = (e) => {
        const {
            id,
            isHidden,
        } = e.target.value;
        const { hideExtraCountries } = this.state;
        if (isHidden && hideExtraCountries) {
            this.setState(
                () => ({
                    hideExtraCountries: false,
                }),
                () => scrollToHash(id, { duration: 0 }),
            );
            return;
        }

        scrollToHash(id, { duration: 0 });
    }

    _renderRegionalData = (data, index) => {
        const {
            hideExtraCountries,
        } = this.state;

        if (!data) {
            return null;
        }

        return (
            <RegionalData
                data={data.carrier_contacts}
                id={data.contact_country_code}
                isHidden={index > NUM_COUNTRIES_TO_SHOW - 1 && hideExtraCountries}
                key={data.contact_country_code}
                region={data.country_name}
            />
        );
    }

    render() {
        const {
            t,
            regionalData,
            regionNames,
        } = this.props;
        const {
            hideExtraCountries,
        } = this.state;

        return (
            <PageSection layoutClassName={styles.layout}>
                <div className={styles.content}>
                    <SectionTitle className={styles.sectionTitle}>
                        {t('contactTitle')}
                    </SectionTitle>
                    <MarkdownContent className={styles.sectionContent}>
                        {t('contactDescription')}
                    </MarkdownContent>
                    <div className={styles.carrierSection}>
                        <ul className={styles.regionalDataContainer}>
                            {regionalData.map(this._renderRegionalData)}
                        </ul>
                        <Button
                            className={styles.seeMore}
                            onClick={this._toggleSeeMoreButton}
                        >
                            {hideExtraCountries
                                ? t('showMoreCountries')
                                : t('showLessCountries')}
                        </Button>
                    </div>
                </div>
                <PlaceDropdown
                    className={styles.placeDropdown}
                    clearable={false}
                    dataset={regionNames}
                    inputClass={styles.placeDropdownContainer}
                    onOptionChange={this._onCountryChange}
                    optionsClass={styles.options}
                    placeholder={t('contactCountryLabel')}
                    poweredByGoogle={false}
                    readOnly
                />
                <BackToTopButton duration={0} />
            </PageSection>
        );
    }
}

CarrierContactList.propTypes = {
    regionalData: PropTypes.arrayOf(
        PropTypes.shape({
            contact_country_code: PropTypes.string,
            country_name: PropTypes.string,
            carrier_contacts: PropTypes.arrayOf(PropTypes.object),
        }),
    ).isRequired,
    regionNames: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            id: PropTypes.string,
            isHidden: PropTypes.bool,
        }),
    ).isRequired,
};

export { CarrierContactList };
const LocalizedCarrierContactList = localize(CarrierContactList, ccConfig.namespace);
export default withRouter(LocalizedCarrierContactList);
